export const GET_TEAMS = 'teams/GET_TEAMS';
export const GET_TEAMS_SUCCESS = 'teams/GET_TEAMS_SUCCESS';
export const GET_TEAMS_ERROR = 'teams/GET_TEAMS_ERROR';

export const GET_ALL_TEAMS = 'teams/GET_ALL_TEAMS';
export const GET_ALL_TEAMS_SUCCESS = 'teams/GET_ALL_TEAMS_SUCCESS';
export const GET_ALL_TEAMS_ERROR = 'teams/GET_ALL_TEAMS_ERROR';

export const TEAM_LOADING_STATE = 'teams/TEAM_LOADING_STATE';
